<template>
  <div style="position:relative" v-bind:class="{ open: openSuggestion }" class="auto-complete">
    <i v-if="matches.length > 0" class="dropdown icon" @click="triggerFocusEvent()"></i>
    <input
      class="form-control search-ul-text"
      type="text"
      :value="value"
      @input="updateValue($event.target.value)"
      ref="inputTag"
      @change="$emit('change',value)"
      @keydown.enter="enter"
      @keydown.down="down"
      @keydown.up="up"
      @blur="blur"
      @click="openDropdown"
      :placeholder="placeholder"
    />
    <ul class="dropdown-menu search-ul" style="width:100%">
      <li
        v-for="(suggestion, index) in matches"
        :key="index"
        v-bind:class="{ active: isActive(index) }"
        @click="suggestionClick(index)"
      >
        <a @mousedown.prevent="down(suggestion)">{{ suggestion }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    suggestions: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    return {
      open: false,
      current: 0,
    };
  },
  computed: {
    // Filtering the suggestion based on the input
    matches() {
      return this.suggestions.filter((obj) => {
        if (obj === null) return false;
        const filteredValue = this.value !== null ? this.value.toLowerCase() : '';
        return obj.toLowerCase().includes(filteredValue);
      });
    },
    openSuggestion() {
      return (
        this.selection !== '' && this.matches.length !== 0 && this.open === true
      );
    },
  },
  methods: {
    triggerFocusEvent() {
      if (!this.open) {
        this.$refs.inputTag.click();
        this.$refs.inputTag.focus();
        this.open = true;
      } else this.open = false;
    },
    openDropdown() {
      this.open = true;
    },
    updateValue(value) {
      if (this.open === false) {
        this.open = true;
        this.current = 0;
      }
      this.$emit('input', value);
    },
    // When enter pressed on the input
    enter() {
      this.$emit('input', this.matches[this.current]);
      this.open = false;
    },
    // When up pressed while suggestions are open
    up() {
      if (this.current > 0) {
        this.current -= 1;
      }
    },
    // When up pressed while suggestions are open
    down() {
      if (this.current < this.matches.length - 1) {
        this.current += 1;
      }
    },
    blur() {
      setTimeout(() => {
        this.open = false;
      }, 200);
      // this.open = false;
    },
    // For highlighting element
    isActive(index) {
      return index === this.current;
    },
    // When one of the suggestion is clicked
    suggestionClick(index) {
      this.$emit('input', this.matches[index]);
      this.open = false;
    },
  },
};
</script>
<style>
.dropdown.icon {
  cursor: pointer;
  position: absolute;
  width: auto;
  height: auto;
  line-height: 1.2142em;
  top: 0.78571429em;
  right: 1em;
  z-index: 3;
  margin: -0.78571429em;
  padding: 0.78571429em;
  opacity: 0.8;
  -webkit-transition: opacity 0.1s ease;
  transition: opacity 0.1s ease;
  float: right;
  font-family: "Dropdown";
  line-height: 1;
  height: 1em;
  width: 1.23em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  font-weight: normal;
  font-style: normal;
  text-align: center;
  font-size: 0.85714286em;
  margin-right: -2px;
  top: 13px;
  color: #555;
}
.auto-complete .search-ul .active a{
  /* border:1px solid #0A99ff !important;
  font-weight: 600 !important; */
}
.auto-complete .search-ul .active a:hover{
  /* border:1px solid #0A99ff !important; */
}
.auto-complete .dropdown-menu > li > a:focus, .dropdown-menu > li > a:hover{
  background-color: none !important;
  border: none !important;
}
.auto-complete .dropdown-menu>.active>a, .dropdown-menu>.active>a:focus, .dropdown-menu>.active>a:hover{
  /* border:1px solid #0A99ff !important; */
}
.auto-complete .dropdown-menu li.active,
.auto-complete .dropdown-menu li:hover{
  border:1px solid #0A99ff !important;
}
.dropdown-menu li{
  padding: 5px 10px 5px 12px;
}
.auto-complete ul{
  padding-top: 6px;
  overflow-x: scroll;
}
/* .auto-complete ul:before{
  content: '';
    display: flex;
    align-items: center;
    position: absolute;
    top: 0px;
    left: 12px;
    right: -13px;
    border: 0.5px solid #000000;
    opacity:0.5;
    width: 96%;
} */
.auto-complete.open:after{
  content: '';
    display: flex;
    align-items: center;
    position: absolute;
    top: 32px;
    left: 12px;
    right: -13px;
    border: 0.5px solid #000000;
    opacity:0.5;
    width: 96%;
}

.auto-complete .dropdown-menu>li>a{
  padding: 0px !important;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300 !important;
  font-size: 18px !important;
  line-height: 25px !important;
  color: #333333 !important;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.open .search-ul{
  border-color: #000000 !important;
  max-height: 229px !important;
}
.auto-complete .form-control{
  padding: 6px 44px 6px 6px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px !important;
  line-height: 25px !important;
  color: #4D4D4D;
  border: 1px solid #4D4D4D !important; ;
  /* border: 0.5px solid #000000 !important; */
}
.auto-complete .form-control::placeholder {
  color: #999999;
  font-weight: 400;
}
.open .form-control.search-ul-text{
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom: none !important;
}
.auto-complete .dropdown.icon:before {
  content: "";
  float: right;
  right: 6px;
  position: absolute;
  top: 4px;
  border: 1px solid #000000;
  padding: 7px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  border-width: 0 1px 1px 0;
}
.open .dropdown.icon:before{
  transform: rotate(225deg) !important;
  top: 12px;
}

.archiving-auto .search-ul .active:hover a {
  background: none!important;
  border: none!important;
}
.archiving-auto .search-ul .active a {
  background: none!important;
  border: none!important;
}
</style>
